import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { DEVICE, SIZE } from '../../../../assets/styles';
import { Pictogram } from '../../../../assets/svg';
import { useGetWindowSize } from '../../../../hooks';

export const ErrorLayout: React.FC = () => {
  const { t } = useTranslation();
  const { width } = useGetWindowSize();
  const isMobile = width < SIZE.laptop;

  return (
    <Root>
      <Title>Whoops! </Title>
      <Description>Something went wrong. Please try refreshing the page</Description>
      <PictogramContainer>
        <Pictogram idPrefix={isMobile ? 'small' : 'big'} />
      </PictogramContainer>
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(65vh);
`;

const Title = styled.h1`
  font-size: 64px;
  font-weight: 600;
  color: var(--color2);
  margin-bottom: 18px;
  @media ${DEVICE.laptop} {
    font-size: 100px;
  }
`;

const Description = styled.h2`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  text-align: center;
  color: var(--color6);
  @media ${DEVICE.laptop} {
    font-size: 24px;
    text-align: left;
  }
`;

const PictogramContainer = styled.div`
  position: absolute;
  bottom: 0;
  & > svg {
    height: 54px;
  }
  @media ${DEVICE.laptop} {
    & > svg {
      height: 120px;
    }
  }
`;
